export const api_host = process.env.HOST;
export const environment = process.env.ENVIRONMENT;
export const payment_link = process.env.PAYMENT_LINK;